module.exports = __webpack_public_path__ + "static/media/voz.c954a83d.svg";